/**
 * Доступ через покупку устройства: модем привязывается из консоли нажатием
 * кнопки на нём, ничего сверх общего приложения не нужно.
 */

import { AccessModule } from '../AccessModule';
import ConsoleBind from './ConsoleBind';
import ConsoleBindCard from './ConsoleBindCard';

const deviceAccess: AccessModule = {
    routes: [],
    adminLinks: [],
    userLinks: [],
    LoginLinks: null,
    ConsoleNotice: null,
    ConsoleEmptyState: ({ onBindOk }) => <ConsoleBind onBindOk={onBindOk} />,
    AddDroneCard: ConsoleBindCard,
    ModemSettingsSection: null,
    UnbindNotice: null,
    AdminModemSection: null,
    showsModemIntegrations: true
};

export default deviceAccess;
